import { D1ToastContent } from '@brands/Components/ToastContainer/D1Toast';
import { AlertColor } from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import React from 'react';

interface GenericSnackbarProps {
  open: boolean;
  message: string;
  type: AlertColor;
  onClose: () => void;
  /**
   * Compatibility prop. Positioning now follows the shared D1 toast content-area anchor.
   */
  anchorInDashboardMain?: boolean;
}

const GenericSnackbar: React.FC<GenericSnackbarProps> = ({
  open,
  message,
  type,
  onClose,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{
        '&.MuiSnackbar-root': {
          bottom: 'var(--d1-toast-bottom, 32px)',
          left: 'var(--d1-toast-content-center, 50vw)',
          right: 'auto',
          width: 'min(394px, var(--d1-toast-available-width, calc(100vw - 32px)))',
          maxWidth: 'calc(100vw - 32px)',
          transform: 'translateX(-50%)',
        },
      }}
    >
      <D1ToastContent message={message} onClose={onClose} variant={type} />
    </Snackbar>
  );
};

export default GenericSnackbar;
